var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsappIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11029_34596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 0.438477C6.51021 0.438477 0.438477 6.51021 0.438477 14C0.438477 16.9046 1.35203 19.5955 2.90685 21.8021L0.438477 27.5616L5.96902 24.928C8.21728 26.583 10.9943 27.5616 14 27.5616C21.4899 27.5616 27.5616 21.4899 27.5616 14C27.5616 6.51021 21.4899 0.438477 14 0.438477Z",
    fill: "#3B71FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 25.2232C20.1985 25.2232 25.2234 20.1983 25.2234 13.9998C25.2234 7.80126 20.1985 2.77637 14 2.77637C7.8015 2.77637 2.77661 7.80126 2.77661 13.9998C2.77661 20.1983 7.8015 25.2232 14 25.2232Z",
    fill: "#E6E9FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5943 16.5554L17.2876 15.8941L15.7188 17.4628C13.0649 16.3382 11.662 14.9352 10.428 12.172L11.9968 10.6032L11.3355 7.29647L9.0579 6.87598C8.55964 6.98918 8.0861 7.2391 7.6981 7.62711C6.94341 8.3818 6.83857 9.43005 6.99356 10.4152C7.3441 12.6437 8.4291 15.625 10.3299 17.5333C10.3345 17.5379 10.339 17.5427 10.3435 17.5473C10.3481 17.5519 10.3529 17.5563 10.3575 17.5609C12.2658 19.4617 15.2471 20.5466 17.4756 20.8973C18.4608 21.0522 19.509 20.9474 20.2637 20.1927C20.6517 19.8047 20.9016 19.3312 21.0148 18.8329L20.5943 16.5554Z",
    fill: "#3B71FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4106 20.018C16.1821 19.6675 13.2008 18.5825 11.2925 16.6817C11.2879 16.6771 11.2832 16.6726 11.2786 16.6681C11.274 16.6635 11.2695 16.6587 11.265 16.6541C9.36413 14.7458 8.27918 11.7645 7.92858 9.53604C7.8011 8.72573 7.84977 7.87299 8.29083 7.17578C8.07886 7.2968 7.87881 7.44643 7.69785 7.62734C6.94317 8.38202 6.83833 9.43027 6.99331 10.4155C7.34386 12.6439 8.42886 15.6252 10.3297 17.5335C10.3343 17.5381 10.3387 17.5429 10.3433 17.5475C10.3479 17.5521 10.3527 17.5565 10.3573 17.5611C12.2656 19.4619 15.2469 20.5469 17.4753 20.8975C18.4605 21.0525 19.5088 20.9476 20.2635 20.1929C20.4049 20.0515 20.5275 19.8984 20.6323 19.7373C19.9624 20.1024 19.168 20.1372 18.4106 20.018Z",
    fill: "#3B71FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11029_34596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.bcba73d290c945b70fd1da2828e24342.svg";
export { ForwardRef as ReactComponent };